import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import './story.scss'
import Layout from '../components/Layout/Layout'
import grandMere from '../assets/grand-mere.png'

const BanoiTitle = styled.span`
  font-family: 'Courier New', Courier, monospace;
  font-size: 32px;
`
const Legend = styled.span`
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
`
const Image = styled.div`
  background: url(${grandMere}) no-repeat;
`

class Story extends React.Component {
  render() {
    return (
      <Layout locale={this.props.pathContext.locale}>
        <div className="row no-gutters pb-3 story-page">
          <div className="col-12 col-lg-5 col-xl-4 pr-0 pr-lg-5">
            <BanoiTitle>[Bà nội]</BanoiTitle>
            <Legend>n.f</Legend>
            <h6 className="text-uppercase mb-4 title-translation">
              <FormattedMessage id="storyFrom" />
            </h6>

            <div className="courier-new story">
              <p>
                L’histoire de Banoi c’est celle de My-Ly Pham, ou plus particulièrement de sa
                grand-mère.
              </p>

              <p>
                D’origine vietnamienne, My-Ly a depuis son enfance fait de nombreux voyages en Asie
                pour retrouver sa famille. Au fil de ces voyages et aux côtés de Banoi, elle a
                découvert la gastronomie d’Asie du Sud-Est, qu’elle a eu rapidement envie de faire
                partager.
              </p>

              <p>
                Alors décidée à créer un restaurant, elle a multiplié les voyages et s’est inspirée
                des cuisines locales pour concevoir à son tour des recettes originales : les cafés
                de Bangkok, la sauce cacahuète de Birmanie, la soupe coco de Thaïlande, et bien
                d’autres clins d’œil à l’Asie composent aujourd’hui ses recettes.
              </p>

              <p>
                Mais la spécialité de Banoi, c’est le rouleau de printemps. Il y est servit en plat,
                comme au Vietnam. On le déguste seul, accompagné d’une soupe coco, de bouchées de
                banh-mi ou même d’un verre de vin blanc.
              </p>

              <p>
                Chez Banoi tout est préparé sur place, avec nos petites mains et les légumes du
                marché voisin. Des rouleaux aux desserts nos recettes sont toutes faites maison et
                se déclinent au gré de nos inspirations.
              </p>
            </div>
          </div>
          <Image className="col-12 col-lg-7 col-xl-8 mt-4 mt-sm-0 img-right" />
        </div>
      </Layout>
    )
  }
}

export default Story



// WEBPACK FOOTER //
// ./src/pages/story.js